import type { Assignment, TargetType } from "./trafficAssignmentsData";

export interface RuleAssignmentFilters {
	search: string;
	ruleId: string;
	targetType: "" | TargetType;
	state: "" | "enabled" | "disabled";
	ruleState: "" | "enabled" | "disabled";
	sort: "rule" | "entity" | "priority";
}
export const emptyRuleAssignmentFilters = (): RuleAssignmentFilters => ({ search: "", ruleId: "", targetType: "", state: "", ruleState: "", sort: "rule" });

export const filterRuleAssignments = (rows: Assignment[], filters: RuleAssignmentFilters): Assignment[] => {
	const terms = filters.search.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
	return rows.filter(row => {
		if (filters.ruleId && String(row.rule_id) !== filters.ruleId || filters.targetType && row.target_type !== filters.targetType) return false;
		if (filters.state && row.enabled !== (filters.state === "enabled")) return false;
		if (filters.ruleState && row.rule_enabled !== (filters.ruleState === "enabled")) return false;
		const text = [row.rule_name, row.rule_id, row.target_name, row.target_type, row.target_id].join(" ").toLocaleLowerCase();
		return terms.every(term => text.includes(term));
	}).sort((a, b) => {
		const byRule = (a.rule_name ?? String(a.rule_id)).localeCompare(b.rule_name ?? String(b.rule_id));
		const byEntity = (a.target_name ?? String(a.target_id)).localeCompare(b.target_name ?? String(b.target_id));
		return (filters.sort === "priority" ? a.priority - b.priority || byRule || byEntity : filters.sort === "entity" ? byEntity || byRule : byRule || byEntity) || a.rule_id - b.rule_id || a.target_type.localeCompare(b.target_type) || a.target_id - b.target_id;
	});
};
